import { render } from "./ArtistView.vue?vue&type=template&id=a3077038"
import script from "./ArtistView.vue?vue&type=script&lang=js"
export * from "./ArtistView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/DMA-Frontend/DMA-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__